import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DocumentoQrComponent } from './components/documento-notarial/documento-qr/documento-qr.component';
import { CartaQrComponent } from './components/documento-notarial/carta-qr/carta-qr.component';
import { LegalizacionFirmaQrComponent } from './components/documento-notarial/legalizacion-firma-qr/legalizacion-firma-qr.component';
import { LibroQrComponent } from './components/documento-notarial/libro-qr/libro-qr.component';
import { HomeComponent } from './page/home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { AppFuncionesService } from './app-funciones/app-funciones.service';
import { PermisoViajeQrComponent } from './components/documento-notarial/permiso-viaje-qr/permiso-viaje-qr.component';
import { ConsultaKardexComponent } from './components/protocolar/consulta-kardex/consulta-kardex.component';
import { HeaderComponent } from './page/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InformacionKardexComponent } from './components/protocolar/consulta-kardex/informacion-kardex/informacion-kardex.component';
import { RelacionKardexsComponent } from './components/protocolar/consulta-kardex/relacion-kardexs/relacion-kardexs.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PoderQrComponent } from './components/documento-notarial/poder-qr/poder-qr.component';
import { CertificadoDomiciliarioQrComponent } from './components/documento-notarial/certificado-domiciliario-qr/certificado-domiciliario-qr.component';
import { CertificadoSupervivenciaQrComponent } from './components/documento-notarial/certificado-supervivencia-qr/certificado-supervivencia-qr.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LibroDeReclamacionesComponent } from './components/libro-de-reclamaciones/libro-de-reclamaciones.component';
import { MatCheckboxModule, MatDatepickerModule, MatNativeDateModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
  declarations: [
    AppComponent,
    DocumentoQrComponent,
    CartaQrComponent,
    LegalizacionFirmaQrComponent,
    LibroQrComponent,
    HomeComponent,
    PermisoViajeQrComponent,
    ConsultaKardexComponent,
    HeaderComponent,
    InformacionKardexComponent,
    RelacionKardexsComponent,
    PoderQrComponent,
    CertificadoDomiciliarioQrComponent,
    CertificadoSupervivenciaQrComponent,
    LibroDeReclamacionesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    NgxSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    MatSelectModule,
    MatRadioModule ,
    MatCheckboxModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AppFuncionesService,NgxSpinnerService],
  bootstrap: [AppComponent]
})
export class AppModule { }
